import React from "react";
import {MainCP}  from "../../Components/modelo-confianza/MainCP"

const ViewModeloConfianza: React.FC = () => <MainCP/>

export default ViewModeloConfianza;